// src/components/layout/sidebar.tsx
import { Link, useLocation,useNavigate } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext";
import { useSupport } from "../../context/SupportContext";
import { useTranslation } from 'react-i18next';
export default function Sidebar(Props) {
  const {toggleSidebar} = Props;
  const navigate = useNavigate();
  const location = useLocation();
  const { logout} = useAuth();
  const { unreadCount } = useSupport();
  const { t } = useTranslation();

   const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };
  const menuItems = [

    { path: '/dashboard', label: t('navigation.dashboard') },
    // { path: '/dashboard/myprofile', label: 'Profile' },
    { path: '/dashboard/wallets', label: t('navigation.wallets') },
    // { path: '/dashboard/counterparties', label: t('navigation.counterparties') }, // Temporarily removed
    { path: '/dashboard/transfers', label: t('navigation.transfers') },
    { path: '/dashboard/cards', label: t('navigation.cards') },
    { path: '/dashboard/transactions', label: t('navigation.transactions') },
    { path: '/dashboard/swap', label: t('navigation.swap') },
    // { path: '/dashboard/investments', label: t('navigation.investment') },
    { path: '/dashboard/referral', label: t('navigation.referral') },
    { path: '/dashboard/support', label: t('navigation.support') },
    // { path: '/dashboard/settings', label: 'Setting' },
  ];
  
  return (
    <>
      <style>{`
        .sidebar-menu-item:hover {
          color: #B3A369 !important;
        }
      `}</style>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '25px',
        paddingLeft: '40px',
        // paddingTop: '60px',
        paddingRight:'20px',
      }}
      className='sm:pt-[60px] sm:h-full overflow-y-auto'>
      {menuItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          style={{
            textDecoration: 'none',
            color: location.pathname === item.path ? '#B3A369' : '#000000',
            fontWeight: location.pathname === item.path ? '800' : 'normal',
            fontSize: '32px',
            transition: 'color 0.3s ease'
          }}
          className={`${(item.label=="Setting")?"sm:hidden":""} sidebar-menu-item`}
          onClick={toggleSidebar} // Close sidebar on link click
        >
          {item.label}
          {item.path === '/dashboard/support' && unreadCount > 0 && (
            <span
              style={{
                backgroundColor: '#ef4444',
                color: 'white',
                borderRadius: '50%',
                padding: '2px 8px',
                fontSize: '18px',
                marginLeft: '10px',
                fontWeight: 'bold',
                minWidth: '24px',
                display: 'inline-block',
                textAlign: 'center'
              }}
            >
              {unreadCount}
            </span>
          )}
        </Link>
      ))}
      <button onClick={handleLogout} style={{
            textDecoration: 'none',
            fontSize: '32px',
            textAlign:"left",
            color: '#000000',
          }}
          className='block sm:hidden'
          >
       {t('common.logout')}
      </button>
      {/* <Link
        to={"/dashboard/referral"}
        onClick={toggleSidebar}
        className="px-6 py-2 border border-[#B3A369] rounded-xl text-[#B3A369] font-semibold hover:bg-belobaba-gold hover:text-white transition sm:mt-auto mb-5 text-center">
        Referral Program
      </Link> */}
    </div>
    </>
  );
}